<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap class="justify-center">
        <v-flex xs12>
          <h3 class="text-center">View Home-Based Care Note</h3>
          <v-card>
            <v-card-title class="py-0">
              <v-btn small text @click="goTo('/home-based-care/' + homeBasedCare.id + '#notes')" outlined>
                <v-icon left>mdi-arrow-left</v-icon>
                Back
              </v-btn>
              <v-spacer></v-spacer>
              Date: {{ note.date }}
            </v-card-title>
            <v-card-text>
              <p v-html="note.details"></p>
            </v-card-text>
            <v-card-actions class="py-0">
              <v-btn small text @click="goTo('/home-based-care/' + homeBasedCare.id + '/home-based-care-notes/' + homeBasedCareNote.id + '/edit')" v-if="canEdit" class="orange--text" outlined>
                <v-icon left>mdi-file-document-edit-outline</v-icon>
                Edit
              </v-btn>
              <v-btn small text @click="deleteNote" v-if="canDelete" :loading="deleting" class="red--text" outlined>
                <v-icon left>mdi-delete</v-icon>
                Delete
              </v-btn>
              <v-spacer></v-spacer>
              Created: {{ moment(note.created_at).format('lll') }}
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/MainLayout'

  export default {
    name: 'HomeBasedCareNoteShow',
    layout,
    props: [
      'home-based-care', 'home-based-care-note', 'canEdit', 'canDelete'
    ],
    components: {},
    metaInfo () {
      return {
        title: 'View Home-Based Care Note',
        titleTemplate: '%s | ' + this.$title,
      }
    },
    data () {
      return {
        deleting: false,
      }
    },
    computed: {
      note () {
        return this.homeBasedCareNote
      }
    },
    methods: {
      deleteNote () {
        swal({
          title: 'Delete Note?',
          text: '',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: 'red',
          confirmButtonText:'Delete',
          closeOnConfirm: false,
          showLoaderOnConfirm: true,
        },
        function () {
          this.deleting = true
          this.$inertia.delete('/home-based-care/' + this.homeBasedCare.id + '/home-based-care-notes/' + this.homeBasedCareNote.id, {
            onFinish: () => {
              this.deleting = false
              swal.close()
            }
          })
        }.bind(this))
      }
    }
  }
</script>
